import axios from 'axios';
import { GET_COMMISSION_HISTORIES, ADD_COMMISSION_HISTORY, EDIT_COMMISSION_HISTORY, DELETE_COMMISSION_HISTORY, COMMISSION_HISTORIES_LOADING, CLEAR_COMMISSION_HISTORIES } from '../types';
import { tokenConfig } from './authActions';
import { returnErrors } from './errorActions';
import { ICommission_history } from '../../types/interfaces';
import store from '../store';

export const getCommission_histories = (duration: any, comId: number, projectId: number | "ALL", chNull: any, chGrayed: any, chRejected: any, chValidated: any, chPaid: any/*, noCommissions: number, validatedCommissions: number*/) => (dispatch: Function, getState: Function) => {
  dispatch({
    type: COMMISSION_HISTORIES_LOADING
  });
  axios
    .get('/api/commissionhistories', {...tokenConfig(getState), params: {duration, comId, projectId, chNull, chGrayed, chRejected, chValidated, chPaid}})
    .then(res =>
      dispatch({
        type: GET_COMMISSION_HISTORIES,
        payload: res.data
      })
    )
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
    });
};

// export const commTest = async () : Promise<any> => {
//   return new Promise((resolve) => {
//   axios
//     .get('/api/commissionhistories/test', {...tokenConfig(store.getState), params: {}})
//     .then(res =>
//       resolve(res.data)
//     )
//     .catch(err => 
//       console.log("err commTest", err)
//     );
//   });
// };

export const verifyCommissionBlock = async (comId: number) : Promise<any> => {
  return new Promise((resolve) => {
  axios
    .get('/api/commissionhistories/verifyCommissionBlock', {...tokenConfig(store.getState), params: {comId}})
    .then(res =>
      resolve(res.data)
    )
    .catch(err => 
      console.log("err verifyCommissionBlock", err)
    );
  });
};

export const addCommission_history = (commission_history: ICommission_history) => (
  dispatch: Function,
  getState: Function
) => {
  axios
    .post('/api/commissionhistories', commission_history, tokenConfig(getState))
    .then(res =>
      dispatch({
        type: ADD_COMMISSION_HISTORY,
        payload: res.data
      })
    )
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
    });
};

export const editCommissionCom = (ids: number[], comId: number, userId: number | undefined, callback: Function) => (
  dispatch: Function,
  getState: Function
) => {
  axios
    .post('/api/commissionhistories/editCom', {ids, comId, userId}, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: EDIT_COMMISSION_HISTORY,
        payload: res.data
      })
      callback(res.data)
    })
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
      callback(false)
    });
};

export const editCommissionFormula = (ids: number[], formulaId: number, userId: number | undefined, callback: Function) => (
  dispatch: Function,
  getState: Function
) => {
  axios
    .post('/api/commissionhistories/changeLinesFormula', {ids, formulaId, userId}, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: EDIT_COMMISSION_HISTORY,
        payload: res.data
      })
      callback(res.data)
    })
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
      callback(false)
    });
};

export const editCommissionComment = (id: number, comment: string, userId: number | undefined, callback: Function) => (
  dispatch: Function,
  getState: Function
) => {
  axios
    .post('/api/commissionhistories/editComment', {id, comment, userId}, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: EDIT_COMMISSION_HISTORY,
        payload: res.data
      })
      callback(res.data)
    })
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
      callback(false)
    });
};

export const correctCommissions = async (comId: number, userId: number | undefined): Promise<any> => {
  return new Promise((resolve, reject) => {
  axios
    .post('/api/commissionhistories/correct', {comId, userId}, tokenConfig(store.getState))
    .then(res =>
      resolve(res)
    )
    .catch(err => {
      reject(err)
    });
  });
};

export const verifyInactifEnc = async () : Promise<any> => {
  return new Promise((resolve) => {
  axios
    .post('/api/commissionhistories/verifyInactifEnc', {}, tokenConfig(store.getState))
    .then(res =>
      resolve(res.data)
    )
    .catch(err => 
      console.log("err verifyInactifEnc", err)
    );
  });
};

export const deleteCommission_history = (id: number) => (
  dispatch: Function,
  getState: Function
) => {
  axios
    .delete(`/api/commissionhistories/${id}`, tokenConfig(getState))
    .then(res =>
      dispatch({
        type: DELETE_COMMISSION_HISTORY,
        payload: id
      })
    )
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
    });
};

export const setCommission_historiesLoading = () => {
  return {
    type: COMMISSION_HISTORIES_LOADING
  };
};

export const clearCommission_histories = () => (
  dispatch: Function,
  getState: Function
) => {
  dispatch({
    type: CLEAR_COMMISSION_HISTORIES
  })
};